import React from 'react';
import PayPalCheckoutButtons from './PayPalCheckoutButtons';

export default function PayPalPaymentSection({
  apiBaseUrl,
  idToken,
  planId,
  billingTerm,
  appOrigin,
  amountUsd,
  orderId,
  orderLoading,
  onCaptureSuccess,
  onError,
}) {
  const ready = Boolean(idToken && orderId);

  return (
    <div className="space-y-3">
      {ready ? (
        <PayPalCheckoutButtons
          apiBaseUrl={apiBaseUrl}
          idToken={idToken}
          planId={planId}
          billingTerm={billingTerm}
          appOrigin={appOrigin}
          amountUsd={amountUsd}
          orderId={orderId}
          onCaptureSuccess={onCaptureSuccess}
          onError={onError}
        />
      ) : (
        <p className="text-sm text-slate-600" role="status">
          {orderLoading ? 'Preparing secure checkout…' : 'Waiting for order…'}
        </p>
      )}

    </div>
  );
}
